// @ts-ignore
import { data as css } from './asset-bin.css';

import AssetItem from './asset-item';
import elt from '../../../html/elt';
import injectCSS from '../../../html/inject-css';
import logging from '../../../logging';
import { UnitEditorAssetItem } from '../../../domain';

const log = logging('components');

export default class AssetBin extends HTMLElement {
    collapse: HTMLElement;
    grid: HTMLElement;
    header: HTMLElement;
    headerButton: HTMLButtonElement;

    constructor() {
        super();
        injectCSS(css);

        this.headerButton = elt('button', {class: 'accordion-button collapsed'});
        this.header = elt('h2', {class: 'accordion-header'}, this.headerButton);
        this.grid = elt('div', {class: 'asset-bin-grid accordion-body'});
        this.collapse = elt('div', {class: 'accordion-collapse collapse'}, this.grid);
    }

    connectedCallback() {
        this.classList.add('accordion-item');

        this.headerButton.innerText = String(this.getAttribute('label'));
        this.headerButton.addEventListener('click', () => {
            if(this.visible) {
                this.hide();
            } else {
                for(const bin of this.parentElement.querySelectorAll('asset-bin')) {
                    (bin as AssetBin).hide();
                }
                this.show();
            }
        });

        this.append(this.header, this.collapse); 
    }

    addItem(item: UnitEditorAssetItem): AssetItem {
        const itemElt = new AssetItem(
            item.label,
            item.cubby
                ?? item.door
                ?? item.drawer
                ?? item.genericAsset
                ?? item.parametricPart
        );
        this.grid.append(itemElt);
        return itemElt;
    }

    show() {
        this.headerButton.classList.remove('collapsed');
        this.collapse.classList.add('show');
        for(const item of this.grid.children) {
            if(item instanceof AssetItem) {
                item.dispatchEvent(new CustomEvent('bin-opened'));
            }
        }
    }

    hide() {
        this.headerButton.classList.add('collapsed');
        this.collapse.classList.remove('show');
    }
    
    get visible(): boolean {
        return this.collapse.classList.contains('show');
    }

}
window.customElements.define('asset-bin', AssetBin);
